
<script>
import load from '@/components/base/load';
import Cookies from 'js-cookie';
export default {
    mixins: [load],
    data() {
        return {
            globalConfig:{
                dictkey:[],
                dictData:{},
                userModuleMethod:[],
                modulecode:'',
                billmain:{},
                dictgroupkey:[]
            },
            billapproveurl:'',
            billKey:'ph_key',
            uiconfig:{},
            uiproconfig:[],
            usercustominfo:{},
            eventObject:['valueChanged','setDataBefore','searchBefore','cellbeginedit','importSuccess','addRowBefore','indexMethod','delRowBefore','delRowAfter','onSelectionChange','formatValue','updateCellConfig','overrideSearchParam','overrideData','refurbishCheck','onSingleChange','onSetRowCheck','onSelect','onSelectCancel','onSelectionChange','customSummary','customImgPath']
        };
    },
    methods:{
        saveGridCol (obj) {
            let para = {};
            para.aid = Cookies.get('user_id') ? Cookies.get('user_id'): 0 ;
            para.sid = Cookies.get('stationId') ? Cookies.get('stationId'): 0 ;
            para.modulecode = this.globalConfig.modulecode;
            para.colset = JSON.stringify(obj.para);
            this.asyncPost(this.OmdUrl.amp, 'usercenter.usercustominfo.saveColset', para, function (data) {
             
            });
        },
        saveScene (obj) {
            let para = {};
            para.aid = Cookies.get('user_id') ? Cookies.get('user_id'): 0 ;
            para.sid = Cookies.get('stationId') ? Cookies.get('stationId'): 0 ;
            para.modulecode = this.globalConfig.modulecode;
            para.filterscene = JSON.stringify(obj.para);
            this.asyncPost(this.OmdUrl.amp, 'usercenter.usercustominfo.saveScene', para, function (data) {
             
            });
        },
        getUserCustomInfo () {
            let self = this;
            let para = {};
            para.aid = Cookies.get('user_id') ? Cookies.get('user_id'): 0 ;
            para.sid = Cookies.get('stationId') ? Cookies.get('stationId'): 0 ;
            para.modulecode = this.globalConfig.modulecode;
             self.synchroPost(this.OmdUrl.amp, 'usercenter.usercustominfo.getUserInfo', para, function (data) {
                if (data.usercustominfo) {
                   self.usercustominfo = data.usercustominfo;
                }
            });
        },
        getUiCustomInfo () {
            let self = this;
            let para = {};
            para.modulecode = this.globalConfig.modulecode;
             self.synchroPost(this.OmdUrl.amp, 'usercenter.uiproconfig.search', para, function (data) {
                if (data.uiproconfig && data.uiproconfig.length > 0 && data.uiproconfig[0].layoutPro) {
                   self.uiproconfig = JSON.parse(data.uiproconfig[0].layoutPro);
                }
            });
        },
     
        init() {
            // 处理模块号提示
            this.globalConfig.modulecode = this.$Method.getUrlParam('modulecode');
            if (!this.globalConfig.modulecode) {
                this.globalConfig.modulecode = this.$Method.getUrlParam('billmoduleid');
            }
            if (this.billmoduleid) {
                this.globalConfig.modulecode = this.billmoduleid;
            }
            if ( this.uiconfig.layoutType !== 'BirtReport') {
                this.uiconfig.resources = this.OmdUrl[this.uiconfig.resources];
            }
           
            if (this.uiconfig.billKey) {
                this.billKey = this.uiconfig.billKey;
            }
            this.setUserModuleMethod();
            this.getUiCustomInfo();
            let tmp = {};
            this.initUiConfig(this.uiconfig,tmp);
            this.initUiCustomConfig();
            if (this.uiconfig.layoutType === 'ListDetails') {
                this.getUserCustomInfo();
                this.uiconfig.billQueryConfig.usercustominfo  = this.$Method.copy(this.usercustominfo);
            }
            if (this.billapproveurl) {
                this.uiconfig.detailConfig.billapproveurl = this.billapproveurl;
            }
            let accounType = Cookies.get('accounType');
            if (accounType) {
                if (accounType === '1' || accounType === '2') {
                    this.uiconfig.menuToolbar.enablePermissions = false;
                }
            }
            this.setDictData();
        },
        initUiConfig(obj,tmp) {
            if (obj instanceof Array) {
                obj.forEach(el => {
                    this.initUiConfig(el,tmp);
                })
            } else {
                if (obj instanceof  Object) {
                    for (let pro in obj) {
                        if (obj[pro] instanceof Array || obj[pro] instanceof Object) {
                            if (pro === 'data') {
                                continue;
                            }
                            this.initUiConfig(obj[pro],tmp);
                        } else {
                            if (pro === 'dictkey') {
                                if (!tmp[obj[pro]]) {
                                    tmp[obj[pro]] = 'Y';
                                    this.globalConfig.dictkey.push(obj[pro]);
                                }
                            }
                            if (this._isFun(pro)) {
                                obj[pro] = this[obj[pro]];
                            }
                        }
                    }
                }
               
            }
        },
        initUiCustomConfig () {
            this.uiproconfig.forEach(el => {
                if (el.pro && el.pro.length > 0) {
                    if (el.isflag === '1') {
                        if (this.uiconfig.layoutType === 'ListDetails' || this.uiconfig.layoutType === 'LeftListRightDetails' || this.uiconfig.layoutType === 'LeftListRightList') {
                            el.pro.forEach(el2 => {
                                this.commonUiCustomConfig(el2,this.uiconfig.billQueryConfig.gridConfig.items);
                            })
                        }
                    }
                    if (el.isflag === '2') {
                        if (this.uiconfig.layoutType === 'ListDetails' || this.uiconfig.layoutType === 'LeftListRightDetails' || this.uiconfig.layoutType === 'LeftTreeRightDetails') {
                            el.pro.forEach(el2 => {
                                this.commonUiCustomConfig2(el2,this.uiconfig.detailConfig.formsConfig.items);
                            });
                        }
                    }
                    if (el.isflag === '3') {
                        if (this.uiconfig.layoutType === 'ListDetails' || this.uiconfig.layoutType === 'LeftListRightDetails' || this.uiconfig.layoutType === 'LeftTreeRightDetails') {
                            let index = this.uiconfig.detailConfig.formsConfig.items.findIndex(el3 => el3.name === el.typename);
                            if (index > -1) {
                                el.pro.forEach(el2 => {
                                    this.commonUiCustomConfig(el2,this.uiconfig.detailConfig.formsConfig.items[index].items);
                                });
                            }
                            
                        }
                    }
                    if (el.isflag === '4') {
                        if (this.uiconfig.layoutType === 'ListDetails' || this.uiconfig.layoutType === 'LeftListRightDetails' || this.uiconfig.layoutType === 'LeftTreeRightDetails') {
                            el.pro.forEach(el2 => {
                                this.commonUiCustomConfig2(el2,this.uiconfig.detailConfig.billDetailConfig.items);
                            });
                        }
                        if (this.uiconfig.layoutType === 'LeftListRightList') {
                             el.pro.forEach(el2 => {  
                                this.commonUiCustomConfig2(el2,this.uiconfig.detailGridsConfig);
                            });
                        }
                    }
                    if (el.isflag === '5') {
                        if (this.uiconfig.layoutType === 'ListDetails' || this.uiconfig.layoutType === 'LeftListRightDetails' || this.uiconfig.layoutType === 'LeftTreeRightDetails') {
                            let index = this.uiconfig.detailConfig.billDetailConfig.items.findIndex(el3 => el3.name === el.typename);
                            if (index > -1) {
                                el.pro.forEach(el2 => {  
                                    if (this.uiconfig.detailConfig.billDetailConfig.items[index].type === 'EditGridCard') {
                                        this.commonUiCustomConfig(el2,this.uiconfig.detailConfig.billDetailConfig.items[index].items);
                                    } else {
                                        this.commonUiCustomConfig(el2,this.uiconfig.detailConfig.billDetailConfig.items[index].formCondig.items);
                                        this.commonUiCustomConfig(el2,this.uiconfig.detailConfig.billDetailConfig.items[index].gridCondig.items);
                                    }
                                });
                            }
                        }
                        if (this.uiconfig.layoutType === 'LeftListRightList') {
                            let index = this.uiconfig.detailGridsConfig.findIndex(el3 => el3.name === el.typename);
                            if (index > -1) {
                                el.pro.forEach(el2 => {  
                                     this.commonUiCustomConfig(el2,this.uiconfig.detailGridsConfig.items[index].items);
                                });
                            }
                        }

                        if (this.uiconfig.layoutType === 'BillSingleGrid') {
                            el.pro.forEach(el2 => {  
                                this.commonUiCustomConfig(el2,this.uiconfig.gridConfig.items);
                            });
                        }
                    }
                }
            });
           
        },
        commonUiCustomConfig(obj,items) {
            let index = items.findIndex(el => el.name === obj.fieldname || el.sname === obj.fieldname);
            if (index > -1) {
                let tmp = {};
                if (obj.fieldtext) {
                    tmp.label = obj.fieldtext
                }
                if (obj.fieldwidth) {
                    tmp.width = Number(obj.fieldwidth);
                }
                if (obj.fieldcol) {
                    tmp.colNum = Number(obj.fieldcol);
                }
                if (obj.fieldvisible) {
                    tmp.visible = false;
                }
                if (obj.fieldrequired) {
                    tmp.required = true;
                }
                 if (obj.defaultValue) {
                    tmp.defaultValue = obj.defaultValue;
                }
                Object.assign(items[index], tmp); 
            }
        },
         commonUiCustomConfig2(obj,items) {
            let index = items.findIndex(el => el.name === obj.fieldname );
            if (index > -1) {
                let tmp = {};
                if (obj.fieldtext) {
                    tmp.title = obj.fieldtext
                }
                if (obj.fieldvisible) {
                    tmp.visible = false;
                }
                Object.assign(items[index], tmp); 
            }
        },
        _isFun (pro) {
            let index = this.eventObject.findIndex(el => el === pro); 
            if (index > -1) {
                return true;
            } else {
                return false;
            }
        },
        setDictData() {
             // 调用字典方法
            if (this.globalConfig.dictkey.length > 0) {
                const dictkey = this.globalConfig.dictkey.join(',');
                this.globalConfig.dictData = this.getDict(dictkey,'code,name,pro1,ddvalue');
            }
            // 自定义添加
            if (this.initUserDict) {
                Object.assign(this.globalConfig.dictData, this.initUserDict());
            }
        },
        setUserModuleMethod() {
            let data = this.getUserModuleMethod(this.globalConfig.modulecode);
            if (data) {
                if (data.modulemethod) {
                    this.globalConfig.userModuleMethod = this.$Method.copy(data.modulemethod);
                }
                if (data.billisworkflow) {
                    this.billisworkflow = data.billisworkflow;
                }
                if (data.billapproveurl) {
                    this.billapproveurl = data.billapproveurl;
                }
            }
        },
        doAction (action) {
            if (!action.name) {
                return;
            }
            const method = action.name;
            const  methodBefore = method + 'Before';
            let flag = true;
            if (this[methodBefore]) {
                flag = this[methodBefore](action);
            }
            if (flag) {
                if (this[method]) {
                    this[method](action);
                } else {
                    this.doPost(action);
                }
            }
        },
        getActionMethod(action) {
            let name = action.name;
            const type = action.name;
            if (type === 'addData') {
                name = 'save';
            }
            if (type === 'saveData') {
                name = 'save';
            }
            if (type === 'delData') {
                name = 'save';
            }
            if (type === 'auditData') {
                name = 'billaudit';
            }
            if (type === 'cancelData') {
                name = 'billcancel';
            }
            if (type === 'voidData') {
                name = 'billvoid';
            }
            if (type === 'billImport' || type === 'importExcel') {
                name = 'importexcel';
            }
            if (type === 'copyData') {
                name = 'copy';
            }
            if (type === 'submitData') {
                name = 'billsubmit';
            }
            if (type === 'revokeData') {
                name = 'billrepeal';
            }
            if (this.getCustomActionMethod) {
                const temp = this.getCustomActionMethod(type, name);
                if(temp) {
                    name = temp;
                }
            }
            return name;
        },
        doPost(action) {
            let flag = true;
            let self = this;
            this.loadingtext = self.getActionName(action);
            const methodAfter = action.name + 'After';
            let method = this.uiconfig.classPrefix + '.' + this.getActionMethod(action);
            this.showLoading();
            let postData = action.para;
            if (action.name === 'saveData') {
                postData = this.$refs.layout.getChangeData();
            }
            if (this.setChangeData) {
                postData = this.setChangeData(action);
            }
            self.asyncPost(this.uiconfig.resources, method, postData, function(data){
                let msg = self.loadingtext +'成功!';
                if (data.msg) {
                    msg = data.msg;
                }
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,3);
                    }, 250);
                });

                if (self.$refs.layout.setPhkey) {
                    if (data instanceof Array) {
                        if (data.length > 0) {
                            self.$refs.layout.setPhkey(data[0][self.billKey]);
                        }
                    } else {
                        if (data[self.billKey]) {
                            self.$refs.layout.setPhkey(data[self.billKey]);
                        }
                    }
                   
                }
               
                if (self[methodAfter]) {
                    self[methodAfter](data);
                }
                if (action.onOk) {
                    action.onOk(action, data);
                }
            },function(data) {
                const msg = self.loadingtext +'失败!' + data;
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,2);
                    }, 250);
                });
                flag = false;
            },function(data) {
                const msg = self.loadingtext +'异常!' + data;
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,2);
                    }, 250);
                });
                flag = false;
            });
            return flag;
        },
        getActionName(action) {
            let btnConfig = this.globalConfig.userModuleMethod.find(el => el.name === action.name);
            if (!btnConfig) {
                btnConfig = this.uiconfig.menuToolbar.items.find(el => el.name === action.name);
            }
            let text = '';
            if (btnConfig && btnConfig.text) {
                text = btnConfig.text;
            }
            if (this.getCustomActionName) {
                const temp = this.getCustomActionName(action.name, text);
                if(temp) {
                    text = temp;
                }
            }
            return text;
        },
        // 下载导入模版
        downTemplate() {
            const url = this.uiconfig.resources;
            let param = this.getDownTemplateParam();
            let billImport = this.getBillImport();
            billImport.setModeltype('down');
            billImport.setDownUrl(url,param);
        },
        getDownTemplateParam () {
            if (this.customGetDownTemplateParam) {
                return this.customGetDownTemplateParam();
            } else {
                let obj = {};
                obj.billmoduleid = this.globalConfig.modulecode;
                return obj;
            }
        },
        // 导入
        billImport(action) {
            const url = this.uiconfig.resources;
            const method =  this.uiconfig.classPrefix + '.' + this.getActionMethod(action);
            let para = this.getImportParam();
            let billImport = this.getBillImport();
            billImport.setModeltype('upload');
            billImport.setUrl(url,method,para);
            billImport.setShowUpload(true);
        },
        // 导入
        importExcel() {
            const url =this.uiconfig.resources;
            const classPrefix = this.uiconfig.classPrefix ;
            let para = this.getImportParam();
            let billImport = this.getBillImport();
            billImport.setUrl(url,classPrefix,para);
            billImport.setShowUpload(true);
        },
        getBillImport() {
            return this.$refs.layout.getBillImport();
        },
        getImportParam () {
            if (this.customGetImportParam) {
                return this.customGetImportParam();
            } else {
                let data = this.getData();
                let obj = {};
                obj[this.billKey] = data[this.billKey];
                let name = 'billno';
                if (this.uiconfig.billImportConfig.importKey) {
                    name = this.uiconfig.billImportConfig.importKey;
                }
                obj.billno = data[name];
                obj.billmoduleid = this.globalConfig.modulecode;
                return obj;
            }
        },
        getHeadForm(name){
            return this.$refs.layout.getForm().getForm(name);
        },
        getDetail(name){
            return this.$refs.layout.getForm().getDetail(name);
        },
        getForm() {
            return this.$refs.layout.getForm();
        },
        getData() {
            return this.$refs.layout.getData();
        },
        getTree () {
            if (this.$refs.layout.getTree) {
                return this.$refs.layout.getTree();
            } else {
                return null;
            }
        },
        getBillQureyGrid () {
            return this.$refs.layout.getBillQureyGrid();
        },
        getMenuToolbar() {
            return this.$refs.layout.getMenuToolbar();
        },
        getGrid () {
            if (this.$refs.layout.getGrid) {
                return this.$refs.layout.getGrid();
            } else {
                return null;
            }
        },
        changedStatus(value) {
           this.$refs.layout.changedStatus(value);
        },
        initForm(data) {
            this.$refs.layout.initForm(data);
        },
        refurbish(value) {
            this.$refs.layout.refurbish(value);
        },
        setDetailVisible(name, value) {
            this.$refs.layout.setDetailVisible(name, value);
        },
        getSelectedNode(){
            return this.$refs.layout.getSelectedNode();
        },
        getDetailGrids(name) {
            return this.$refs.layout.getDetailGrids(name);
        },
        getReportConfig () {
	        let reportfile = '';
            let self = this;
	        let searchParam = {'moduleid': this.globalConfig.modulecode};
            self.synchroPost(this.OmdUrl.mall, 'mss.base.reportconfig.search', searchParam, function (data) {
                if (data.reportconfig && data.reportconfig.length > 0) {
                   reportfile =data.reportconfig[0].reportfile;
                }
            });
	        return reportfile;
        },
        initBillApprovalData(obj) {
            let self = this;
            self.synchroPost(this.OmdUrl.mallmaster, 'master.mdm.portal.refurbishBillApproval', obj, function (data) {
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/base.vue